import { AxiosError } from 'axios';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { createRequestTypes, GET_OFFICE_REVIEW_INFO } from '../actions';
import { apiMethods } from '../services/api';
import { apiMethodsConst } from '../services/methods';

type TApiMethodKey = keyof typeof apiMethods;

function* callAndDispatch(method: TApiMethodKey, payload?: any): Generator<any, any, any> {
  const response = yield call(apiMethods[method], payload);
  yield put({ type: method, payload: response });
  return response;
}

function* watchGetOfficeRating(): Generator<any, void, any> {
  const events: any = createRequestTypes(GET_OFFICE_REVIEW_INFO);

  function* handler({ payload }: { payload: { userId: string } }): Generator<any, void, any> {
    yield put({ type: events.REQUEST });

    try {
      yield* callAndDispatch(apiMethodsConst.GET_OFFICE_REVIEW_INFO_REQUEST, {
        userId: payload.userId,
      });

      yield put({ type: events.SUCCESS });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }

  yield takeEvery(GET_OFFICE_REVIEW_INFO, handler as any);
}

export default function* sagaOfficeReview(): Generator<any, void, any> {
  yield all([fork(watchGetOfficeRating)]);
}
